{
  "029ef6f4f0667bd9": "Could not send the invite. Please try again.",
  "0424c75bd89ccd79": "Turnover Management",
  "05c79b2de04cd81a": "Attrition deadline",
  "0710b88de3abd3ff": "Hours worked",
  "07548c2c6511d4d1": "Expand",
  "07a2d579c3f0d325": "Starred",
  "0b4243f09a2f1e18": "Next shift",
  "0ee285fd8fb204b1": "Soon ({{minDays}}-{{maxDays}}d)",
  "1016c07b0f58d365": "Toggle password visibility",
  "10995167701b917f": "First shift",
  "12d4885ac31f81d2": "View worker profile",
  "143d7c5951940e20": "Invited {{workerName}} to the visit.",
  "16f5c76194abea44": "Failed to update worker credentials.",
  "18f2a0947f9d6523": "Blocked",
  "18fdd549b2ed367a": "New",
  "19766ed6ccb2f4a3": "Cancel",
  "199a694d51e3e238": "No DNR records found",
  "19c73a5cdf346d96": "Professional",
  "1c8ac867f052ea4a": "Visit",
  "1ebe33a7ca0e9b6a": "An error occurred loading person number",
  "1f39af20f9f76f6f": "with questions.",
  "1fd9ae1607aa3d80": "Invite",
  "22b8701f928b506a": "All license types",
  "24994239b28b5d66": "This professional has been blocked from your workplace.",
  "257c8051763d5f71": "Share credentials",
  "29382cedf177bab3": "Couldn't load professionals. Please try again.",
  "2e71da3a95d291bc": "Search for a professional",
  "31e392d1c0378bec": "Apply",
  "322d4240e1f506a4": "Charting password",
  "34b09cd6a31d5c6b": "Loading cases...",
  "35b50b5750239f6d": "No upcoming professionals",
  "35e2d9bb75fa0910": "{{count}} day left",
  "36931a940259dfe1": "Blocked by",
  "37a4c617eaf23768": "No professionals match this filter.",
  "433edf86242299ad": "Charting software",
  "44b23f3add41fbac": "Starred professional",
  "460b3a7da007b7af": "Chat",
  "4b989bb982644a34": "Close booked shifts",
  "4bd715c382a8f125": "Share credentials in bulk",
  "4c99602501042e23": "Last visit from",
  "4d0dccebdf232cdf": "At your workplace",
  "4d8548279e5ec890": "Roster only, NOT a Clipboard worker: DO NOT CONTACT. Message",
  "4e9682fa850ed767": "hrs",
  "546ebb8eb993ea56": "Filters",
  "56bfed64111593cd": "No professionals yet",
  "56cdd09bb76b92df": "Filter turnover risks",
  "58ffa3984521da53": "Upcoming Professionals",
  "594d6f25059d8281": "Could not load cases.",
  "5a6622b6c936e060": "Edit credentials",
  "5f1a2542e4e4ca5e": "Upcoming",
  "5fbd94fab10dd609": "Last shift",
  "6497caa0b3ed4629": "Star professional",
  "663ea1bfffe5038f": "to",
  "6b7c6c52597851ea": "Blocked professional",
  "6c328e4982bfaf41": "No past professionals",
  "6da1b79e34feeb7f": "Later ({{minDays}}-{{maxDays}}d)",
  "6e6efd60da4a33c3": "Clock in/out",
  "6f1e379f2503a270": "Credentials updated successfully",
  "6fba4e15a1cbf99d": "Credentials were updated, but the workplace default password could not be saved. Please retry.",
  "708e415f9ac11beb": "My Professionals",
  "712da63171e0c9de": "Unblock",
  "72ed245d2cf11822": "Reasons",
  "72f256afd196ceae": "License type",
  "771fec220e68bb00": "This professional has no upcoming shifts.",
  "79d05966d82ae951": "Blocked date",
  "856e3761c64cb75a": "Failed to share credentials, please try again.",
  "8662c0452eadf09c": "No professionals at risk of attrition.",
  "878bdbf15dccac2e": "{{count}} days left",
  "898e26e85b0af7fb": "Last visit to",
  "8a7525b1492fb848": "Notes",
  "9366db524dd21853": "Filter past professionals",
  "937d7af2b0a4d271": "name tmz",
  "942087cc2d41e013": "Retry",
  "943318c70926fdae": "No open visits available to invite {{workerName}} to.",
  "981038b9aea98b69": "Invite staff",
  "9b18491d601d3708": "Current workplace",
  "9efd44c8a075af86": "Unstar professional",
  "9fb0aedc4603d8ac": "Professional not onboarded yet",
  "a52ace420f2175d0": "All",
  "a593cc9212aba25d": "All cases",
  "a64dd88e87280ca6": "Credentials were updated, but the external ID could not be saved. Please retry.",
  "a6a5fc451f8f8e92": "Professionals on your DNR list cannot be added to your starred list",
  "b36d293309ceff16": "Keep this aligned with the workplace system so the professional can start cleanly.",
  "b4e929d8bcfe0418": "Documents",
  "b56317a404c818d8": "Now (≤{{maxDays}}d)",
  "b8ed5279e897be5d": "Sending…",
  "baaa3007f92b4afd": "Open filters",
  "bd40133d140c53ee": "Save as workplace default password",
  "be6eb1fc3b05bf9d": "Collapse",
  "bf5a7af358e1e492": "Last logged visit",
  "bfd993fceff3d122": "Invite to case",
  "c06a54a00e88facc": "Next shift {{date}}",
  "c1ad5dcf2e0576ad": "Send Invite",
  "c884fe234d8c8d70": "{{hours}} hrs",
  "c922464a23f03bfc": "Last shift worked",
  "c9b42f3a21a74161": "Total visits",
  "ca1530e8d7017547": "Past",
  "ca2025fdc8918fe6": "This professional has no past shifts.",
  "cc6ed3013b909ae3": "No reasons provided",
  "cd8c3f07cf2f3a40": "Filter upcoming professionals",
  "ce2b12db8242d7b9": "{{deadline}} · {{daysLeft}}",
  "d0a435de6fc4a493": "View documents",
  "d1bf045bb524dae5": "View details",
  "d48a617c7da5163c": "Credentials",
  "d694eaeed5f7e39d": "Once starred, this professional will be highlighted in invite and chat flows when you post new shifts.",
  "daee7606b339f3c3": "Reset",
  "e81144088c20897e": "Last shift {{date}}",
  "ec73df6c916275b0": "Past Professionals",
  "eceb255ef3b5061f": "Credentials needed",
  "f10988e79e8d9a49": "All types",
  "f12dee008fc34050": "Charting username",
  "f3314dc78a3e0b64": "Booked Shifts",
  "f412ebc3df40018a": "Save credentials",
  "f71081fb0af48ae6": "Break",
  "f8d46c2570e70736": "More actions",
  "f9d37c23fcc0f03c": "urgent"
}
